import React, { useEffect, useState } from 'react';
import 'bootstrap-select';
import { useSelector } from 'react-redux';
import { useParams, useNavigate, Link } from 'react-router-dom';
import VersionService from 'service/VersionService';
import { VersionCreateReq } from 'domain/payload/request/version/VersionCreateReq';
import { VersionUpdateReq } from 'domain/payload/request/version/VersionUpdateReq';
import LoadingSpinner from 'component/LoadingSpinner';
import CustomDropdown from 'component/CustomDropdown';
import BooleanSlider from 'component/BooleanSlider';
import { Option } from 'domain/model/Option';

const VersionForm: React.FC = () => {

  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const navigate = useNavigate();

  const versionService = VersionService();

  // INPUT STATE
  const [platformKey, setPlatformKey] = useState(0);
  const [versionNumber, setVersionNumber] = useState(0);
  const [versionName, setVersionName] = useState('');
  const [forceUpdate, setForceUpdate] = useState(false);
  const [updateUrl, setUpdateUrl] = useState('');

  // CONFIG
  const [platformList, setPlatformList] = useState<Option[]>([])

  // LOADING
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setIsLoadingSave(true)
    try {
      if (id == "0") {
        await versionCreate()
        alert(`Data ${versionName} successfully created!`)
        navigate("/version")
      } else {
        await versionUpdate()
        alert(`Data ${versionName} successfully updated!`)
        navigate("/version")
      }
      setIsLoadingSave(false)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat menyimpan data';
      alert(`Error: ${errorMessage}`);
      setIsLoadingSave(false)
    }
  };

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setIsLoadingDetail(true)
    try {
      const res = await versionService.versionDetail(token, id ?? "0");
      console.log(res)
      setPlatformKey(res.data?.platform?.key!)
      setVersionNumber(res.data?.versionNumber!)
      setVersionName(res.data?.versionName!)
      setForceUpdate(res.data?.forceUpdate!)
      setUpdateUrl(res.data?.updateUrl!)

      const config = await versionService.versionConfig(token)
      setPlatformList(config.data?.platformList!)

      setIsLoadingDetail(false)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil detail version';
      window.alert(`Error: ${errorMessage}`);
      setIsLoadingDetail(false)
    }
  };

  const versionCreate = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    try {
      var request: VersionCreateReq = {
        platformKey: platformKey,
        versionNumber: versionNumber,
        versionName: versionName,
        forceUpdate: forceUpdate,
        updateUrl: updateUrl
      }

      await versionService.versionCreate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  const versionUpdate = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    try {
      var request: VersionUpdateReq = {
        id: id!,
        platformKey: platformKey,
        versionNumber: versionNumber,
        versionName: versionName,
        forceUpdate: forceUpdate,
        updateUrl: updateUrl
      }

      await versionService.versionUpdate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  useEffect(() => {
    if (id != "0") {
      fetchDetail()
    }
  }, [])

  return (

    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">{id == "0" ? "Add Version" : "Edit Version"}</h4>
        <div className="p-4" style={{ background: 'white' }}>
          {
            isLoadingDetail ?
              <LoadingSpinner />
              :
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div>
                      <h5 className="mb-4">Basic Information</h5>
                      <div className="mb-3">
                        <label htmlFor="platformKey" className="form-label fw-semibold">Platform</label>
                        <CustomDropdown
                          value={platformKey}
                          options={platformList.map(p => ({ id: p.key, name: p.value }))}
                          onChange={(option) => setPlatformKey(Number(option.id))}
                          containerClassName="w-100"
                          buttonClassName="form-control form-control-compact w-100 d-flex align-items-center justify-content-between text-start bg-white text-dark border rounded-3"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="versionName" className="form-label fw-semibold">Version Name</label>
                        <input
                          type="text"
                          id="versionName"
                          className="form-control form-control-compact"
                          value={versionName}
                          placeholder="Version Name"
                          onChange={(e) => setVersionName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="versionNumber" className="form-label fw-semibold">Build Number</label>
                        <input
                          type="number"
                          id="versionNumber"
                          className="form-control form-control-compact"
                          value={versionNumber}
                          placeholder="Version Number"
                          onChange={(e) => setVersionNumber(Number(e.target.value))}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div>
                      <h5 className="mb-4">Additional Information</h5>

                      <div className="mb-3">
                        <label htmlFor="email" className="form-label fw-semibold">Is Force Update?</label><br />
                        <BooleanSlider value={forceUpdate} onChange={(val) => setForceUpdate(val)} label={''} />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="updateUrl" className="form-label fw-semibold">Download URL</label>
                        <input
                          type="text"
                          id="updateUrl"
                          className="form-control form-control-compact"
                          value={updateUrl}
                          placeholder="Update URL"
                          onChange={(e) => setUpdateUrl(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-100 d-flex justify-content-end">
                  <Link to="/version">
                    <button className="btn btn-outline-primary">Cancel</button>
                  </Link>
                  <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center ms-2" disabled={isLoadingSave}>
                    {
                      isLoadingSave &&
                      <>
                        <LoadingSpinner reverse={true} />
                        <p className="ms-2"></p>
                      </>
                    }
                    Save
                  </button>
                </div>
              </form>
          }
        </div>
      </div>
    </div>
  );

};

export default VersionForm;